module.exports = __webpack_public_path__ + "img/avatar.59a859c6.png";